const config = {
    // baseUrl: 'http://127.0.0.1:8000/api/',
    baseUrl: 'https://wefinder-server.studiochain.ir/api/',
    endPoints: {
        login: 'login/',
        status: 'status/',
        login_refresh: 'login/refresh/',
        dashboards: 'dashboards/',
        holder: 'holder/',
        balance: 'balance/',
        dashboards_tokens: 'dashboards/tokens/',
        analysis: 'analysis/',
        add_token: 'tokens/add/',
        tokens: 'tokens/',
        action: 'action/',
    }
};
export default config;